import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Text } from '@qga/roo-ui/components';
import PayWithButtonGroup from 'components/PayWithButtonGroup';
import { getIsPointsPay } from 'store/ui/uiSelectors';
import { updateQuery as updateQueryAction } from 'store/propertyAvailability/propertyAvailabilityActions';
import { getQueryPayWith } from 'store/router/routerSelectors';
import { setIsPointsPay } from 'store/ui/uiActions';
import { getIsLoading as getIsLoadingStandard } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import { getIsLoading as getIsLoadingExclusive } from 'store/exclusiveOffer/exclusiveOfferSelectors';
import useRemovePointsPlusPay from 'hooks/optimizely/useRemovePointsPlusPay';

const PayWith = ({ ...rest }) => {
  const queryPayWith = useSelector(getQueryPayWith);
  const isPointsPay = useSelector(getIsPointsPay);
  const dispatch = useDispatch();
  const propertyLoading = useSelector(getIsLoadingStandard);
  const exclusivePropertyLoading = useSelector(getIsLoadingExclusive);
  const isDisabled = propertyLoading || exclusivePropertyLoading;

  const { removePointsPlusPay } = useRemovePointsPlusPay();
  const pointsPlusPayEnabled = !removePointsPlusPay;
  const payWith = pointsPlusPayEnabled ? (isPointsPay ? 'pointsPlusPay' : queryPayWith) : queryPayWith;

  useEffect(() => {
    if (pointsPlusPayEnabled) return;

    dispatch(setIsPointsPay(payWith === 'points'));
  }, [dispatch, payWith, pointsPlusPayEnabled]);

  const updateQuery = useCallback(
    ({ payWith }) => {
      if (!pointsPlusPayEnabled) {
        dispatch(updateQueryAction({ payWith }));
        return;
      }

      if (payWith === 'pointsPlusPay' && queryPayWith !== 'points') {
        dispatch(updateQueryAction({ payWith: 'points' }));
        dispatch(setIsPointsPay(true));
      } else if (payWith === 'pointsPlusPay') {
        dispatch(setIsPointsPay(true));
      } else {
        dispatch(setIsPointsPay(false));
        dispatch(updateQueryAction({ payWith }));
      }
    },
    [dispatch, pointsPlusPayEnabled, queryPayWith],
  );

  return (
    <Flex alignItems="flex-end" flexDirection="column" ml="auto" position="relative" width="100%">
      <PayWithButtonGroup
        {...rest}
        pointsPlusPayEnabled={pointsPlusPayEnabled}
        payWith={payWith}
        updateQuery={updateQuery}
        isDisabled={isDisabled}
      />
      <Text color="greys.steel" mt={2} display="block" data-testid="minimum-points-message">
        Use min. 5,000 points
      </Text>
    </Flex>
  );
};

export default PayWith;
